import React, { useState } from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import styles from "../../styles/components/ui/InputField.module.css";

const InputField = ({
  id,
  name,
  label,
  type = "text",
  placeholder = "",
  value,
  onChange,
  required = false,
  error = "",
  autoComplete = "off",
  isPassword = false,
}) => {
  const [showPwd, setShowPwd] = useState(false);

  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label} {required && <span className={styles.requiredStar}>*</span>}
        </label>
      )}

      <div className={styles.inputWrapper}>
        <input
          id={id}
          name={name}
          type={isPassword ? (showPwd ? "text" : "password") : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
          className={`${styles.input} ${error ? styles.inputError : ""}`}
        />
        {isPassword && (
          <button
            type="button"
            className={styles.iconButton}
            onClick={() => setShowPwd((v) => !v)}
            tabIndex={-1}
            aria-label={showPwd ? "Hide password" : "Show password"}
          >
            {showPwd ? <MdVisibilityOff /> : <MdVisibility />}
          </button>
        )}
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default InputField;